<div class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[1000]" (click)="onClose()">
  <div class="relative bg-white rounded-3xl px-8 pt-12 pb-8 max-w-[400px] w-[90%] flex flex-col items-center shadow-[0_20px_60px_rgba(0,0,0,0.3)]" (click)="$event.stopPropagation()">
    <button class="absolute top-5 right-5 bg-transparent border-none cursor-pointer text-gray-500 p-1 flex items-center justify-center transition-colors hover:text-gray-700" (click)="onClose()">
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <line x1="18" y1="6" x2="6" y2="18"></line>
        <line x1="6" y1="6" x2="18" y2="18"></line>
      </svg>
    </button>
    
    <div class="mb-6 flex items-center justify-center">
      <img *ngIf="!isSuccess" src="/assets/svgs/error_circle.svg" alt="Error Circle">
      <img *ngIf="isSuccess" src="/assets/svgs/check_circle.svg" alt="Success Circle">
    </div>
    
    <p class="text-xl font-semibold text-gray-800 text-center m-0 mb-8 leading-[1.4] max-w-[360px]">{{ message }}</p>
    
    <button class="w-full max-w-[400px] py-4 px-8 bg-[#0066FF] text-white border-none rounded-[50px] text-base font-semibold cursor-pointer transition-all hover:bg-[#0052cc] active:scale-[0.98]" (click)="onAction()">
      {{ buttonText }}
    </button>
  </div>
</div>
